import axios from 'axios'
import { getCookie } from 'common/utils/cookies'
import { getRequestIdUrl } from 'tickets/utils/urlUtils'

const addAnalyticsIds = (config) => {
  if (!config.params) {
    config.params = {}
  }

  config.params.uid = getCookie('uid')
  config.params.aqid = getCookie('aqid')
  config.params.requestId = getRequestIdUrl()
}

/* Creates a custom axios instance that adds analytics IDs (UID/AQID) to the query string of requests.
 * To avoid sending analytics IDs, set config.sendAnalyticsIds to false.
 */
const createCustomInstance = () => {
  const instance = axios.create()

  instance.interceptors.request.use((config) => {
    if (config.sendAnalyticsIds !== false) {
      addAnalyticsIds(config)
    }

    return config
  })

  return instance
}

const r2rServicesClient = createCustomInstance()
export default r2rServicesClient
